module.exports = __webpack_public_path__ + "files/2e6e9095db45c5c3da45171b302139ed.png";